module.exports = __webpack_public_path__ + "76c019833e07208e66384ca80b89417f.svg";